import { useState } from "react";
import { useData } from "@/hooks/useData";
import { Fuel, FuelUnit } from "@/types/fuels/fuels.types";
import { useFuelFilters } from "./useFuelFilters";

export const useFuelTable = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showArchived, setShowArchived] = useState(false);
  const [nameFilters, setNameFilters] = useState<string[]>([]);
  const [unitFilters, setUnitFilters] = useState<FuelUnit[]>([]);

  const { data: fuels, loading, refetch } = useData<Fuel>({
    collectionName: "setup_fuels",
  });

  const { filteredFuels, getUniqueOptions } = useFuelFilters({
    fuels: fuels || [],
    searchTerm,
    showArchived,
    nameFilters,
    unitFilters,
  });

  const nameOptions = getUniqueOptions("name");
  const unitOptions = getUniqueOptions("unit");

  const clearFilters = () => {
    setNameFilters([]);
    setUnitFilters([]);
    setSearchTerm("");
  };

  return {
    fuels: filteredFuels,
    isLoading: loading,
    refetch,
    searchTerm,
    setSearchTerm,
    showArchived,
    setShowArchived,
    nameFilters,
    setNameFilters,
    unitFilters,
    setUnitFilters,
    nameOptions,
    unitOptions,
    clearFilters,
  };
}; 